import { locale } from '@/utils/locale';

export const productItemLocale = {
  routeSitesPages: locale('routes.sitesPage'),
  routesNewSite: locale('routes.newSite'),
  createSiteButton: locale('title.sitesCreate'),
};
